import { render, staticRenderFns } from "./OrgWebhooks.vue?vue&type=template&id=3015abdd&"
import script from "./OrgWebhooks.vue?vue&type=script&lang=js&"
export * from "./OrgWebhooks.vue?vue&type=script&lang=js&"
import style0 from "./OrgWebhooks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports